export const COMMISSION_RATE = 0.05;
